// extracted by mini-css-extract-plugin
export var breadcrumb = "_1e-2";
export var breadcrumbArrow = "_1e-3";
export var breadcrumbs = "_1e-0";
export var link = "_1e-4";
export var small = "_1e-1";